import Raven from "raven-js";

// only add raven if we are in production
const URL = window.location.href;
if (URL.indexOf("torneio.herokuapp.com") > 0) {
  Raven.config(
    "https://08151ca872db4f1ebf76dc33bfe485f9@sentry.io/1252593",
  ).install();
}



// WEBPACK FOOTER //
// ./src/bootstrap/raven.js